import React, { useState, useRef, useEffect } from "react";
import styled, { createGlobalStyle } from 'styled-components'
import ReactSlider from 'react-slider'

const GlobalStyles = createGlobalStyle`
  html {
    font-size: 62.5%;
    font-family: 'Roboto';
    font-weight: 300;
  }
`

const MainWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
`


const CalculatorContainer = styled.div`
  max-width: 590px;
  border: 1px solid rgb(0, 140, 154);
  padding: 20px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 60px;
  box-shadow: 0 0 0 1px rgb(12, 189, 207);
`

const EXITLogo = styled.img`
    max-width: 250px;
    margin-top: -63px;
`

const Title = styled.div`
  color: rgb(0, 140, 154);
  font-weight: 800;
  font-size: 25px;
  margin-top: 20px;
  text-align: center;
  font-family: 'Poppins', sans-serif;
`

const Description = styled.div`
  color: #212121;
  font-weight: 400;
  font-size: 15px;
  margin-top: 10px;
  padding: 0 20px;
  text-align: center;
  line-height: 22px;
  font-family: 'Poppins', sans-serif;
`

const BoxesContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-top: 20px;


  @media only screen and (max-width: 450px) {
    flex-direction: column;
  }
`

const Box = styled.div`
  width: 28%;
  text-align: center;
  background: linear-gradient(180deg, rgba(89,207,219,1) 13%, rgba(10,112,134,1) 92%);
  border-radius: 5px;
  padding: 20px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  @media only screen and (max-width: 450px) {
    width: 95%;
    margin-bottom: 15px;
  }
`

const SvgIconBox = styled.div`
    
`

const BoxTitle = styled.div`
  color: white;
  font-size: 16px;
  font-weight: 600;
  margin-top: 15px;
  font-family: 'Poppins', sans-serif;
`

const BoxDescription = styled.div`
  color: #ededed;
  font-size: 12px;
  font-weight: 400;
  line-height: 13px;
  margin-top: 5px;
  padding: 0 5px;
`

const Input = styled.input`
  width: 80%;
  margin-top: 10px;
  border: 0px solid white;
  padding: 7px;
  border-radius: 3px;
  text-align: center;
  font-weight: 600;
  color: #454444;
  font-size: 14px;
  font-family: 'Roboto', sans-serif;
  padding-left: 19px;
`

const ResultsDescription = styled.div`
  font-size: 20px;
  font-weight: 700;
`

const ResultsDescriptionCount = styled.span`
  color: #0baaba;
  text-decoration: underline;
`

const Results = styled.div`

`

const Hr = styled.div`
  box-shadow: 0 0 0 1px #eeeeee;
  margin-top: 20px;
  margin-bottom: 20px;
  width: 300px;
`

const Footer = styled.div`
  font-size: 10px;
  text-align: center;
  font-weight: 400;
  margin-top: 20px;
  text-align: center;
  padding: 0
`

const ShareButton = styled.div`
  background-color: rgb(0, 140, 154);
  padding: 15px 20px;
  color: white;
  font-size: 15px;
  font-weight: 500;
  border-radius: 5px;
  width: 30%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  cursor: pointer;
  position: relative;
`

const ResultsPrice = styled.div`
  color: rgb(0,140,154);
  font-size: 37px;
  font-weight: 900;
  margin-top: 5px;
  letter-spacing: 1px;
`


const StyledSlider = styled(ReactSlider)`
  width: 50%;
  height: 25px;
  margin-top: 25px;


  @media only screen and (max-width: 500px) {
    width: 80%;
  }
`;

const StyledThumb = styled.div`
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  font-weight: 600;
  width: 35px;
  text-align: center;
  background-color: rgb(0, 140, 154);
  color: #fff;
  border-radius: 50%;
  cursor: grab;
  margin-top: -5px;
  border: 0px solid black;

  &:focus-visible {
    border: 0px solid black;
    outline: none;
  }
`;

const Thumb = (props, state) => <StyledThumb {...props}>{state.valueNow}</StyledThumb>;

const StyledTrack = styled.div`
    top: 0;
    bottom: 0;
    background: ${props => (props.index === 0 ? '#39a5bd' : '#eeeeee')};
    border-radius: 999px;
`;

const Track = (props, state) => <StyledTrack {...props} index={state.index} />;

const Modal = styled.div`
  position: absolute;
  z-index: 9999;
  display:flex;
  align-items: center;
  justify-content: center;
  bottom: 0;
  right: -151px;


  @media only screen and (max-width: 550px) {
    bottom: 58px;
    right: unset;
  }
`

const ModalContainer = styled.div`
  background-color: #eeeeee;
  min-width: 130px;
  min-height: 100px;
  border-radius: 10px;
  border: 1px solid #c9c9c9;
`

const ShareItem = styled.div`
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 12px;
  padding: 12px;
  color: #212121;
  cursor: pointer;
  font-family: 'Poppins', sans-serif;
`
const ShareItemMobile = styled.a`
  display: none;
  align-items: center;
  font-weight: 600;
  font-size: 12px;
  padding: 12px;
  color: rgb(30, 48, 80);
  cursor: pointer;


  @media only screen and (max-width: 450px) {
    display: flex;
    align-items: center;
    font-weight: 600;
    font-size: 12px;
    padding: 12px;
    color: rgb(30, 48, 80);
    cursor: pointer;
  } 
`

const ShareHr = styled.div`
    border-top: 0.5px solid #c9c9c9;
`

const ShareIcon = styled.div`
    width: 35px;

`;

const CloseItem = styled.div`
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 12px;
  padding: 12px;
  color: rgb(30, 48, 80);
  cursor: pointer;
  justify-content: center;
`

function App() {

  const [agents, setAgentCount] = useState(3)
  const [commission, setCommission] = useState(5000)
  const [transactions, setTransactions] = useState(12)
  const [year, setYear] = useState(10)
  const [results, setResults] = useState(0)
  const [shareModal, setShareModal] = useState(false)
  const [showSlider, setShowSlider] = useState(false)
  const [externalUrl, setExternalUrl] = useState("")
  const [forceSMS, setForceSMS] = useState(false)

  const calculate = () => {
    let total = 0

    for (let yearCalculate = 1; yearCalculate <= year; yearCalculate++) {
      total += calculatePerYear(agents*yearCalculate)
    }

    setResults(total.toFixed(0))
  }


  const calculatePerYear = (agentsYear) => {

    const calcValue = agentsYear * (commission * transactions) * 0.1
    const capValue = agentsYear * 10000
    const result = Math.min(calcValue, capValue)


    return (result)
  }

  const generateShareUrl = (site) => {
    let url = externalUrl ? externalUrl : "code.exitrealty.com/code-widgets/lib-residual-calculator-v2/build/"
    let calc = `${agents},${commission},${transactions},${year}`

    url = `https://${url}?calc=${calc}`

    console.log("CLICK")

    if (site == "facebook") {
      window.open(`https://www.facebook.com/sharer.php?u=${url}&t=At EXIT Realty, our Formula of single-level residuals unlocks the potential for unlimited income, and a secure future with retirement, lifestyle, and beneficiary benefits. See how much you could be earning`, '_blank');
    }

    if (site == "twitter") {
      window.open(`https://twitter.com/share?url=${url}&t=At EXIT Realty, our Formula of single-level residuals unlocks the potential for unlimited income, and a secure future with retirement, lifestyle, and beneficiary benefits. See how much you could be earning`, '_blank');
    }

    if (site == "email") {
      window.open(`mailto:?subject=EXIT Realty's Residual Income Calculator&body=${encodeURIComponent(`At EXIT Realty we pride ourselves on doing things differently! With our Formula of single-level residuals, not only do you unlock the potential for unlimited income, but you gain access to a secure future with retirement, lifestyle, and beneficiary benefits. The numbers are in! See how much you could be earning: ${url}`)}`, '_blank');
    }

    if (site == "sms") {

      if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        window.open(`sms:&body=Earn passive income on top of commission, only at EXIT Realty! See how much you could be earning: ${url}`, '_blank');

      } else {
        window.open(`sms:?body=Earn passive income on top of commission, only at EXIT Realty! See how much you could be earning: ${url}`, '_blank');

      }
    }
  }


  const parseURLParams = () => {

    let url = window?.location?.href

    var queryStart = url.indexOf("?") + 1,
        queryEnd   = url.indexOf("#") + 1 || url.length + 1,
        query = url.slice(queryStart, queryEnd - 1),
        pairs = query.replace(/\+/g, " ").split("&"),
        parms = {}, i, n, v, nv;

    if (query === url || query === "") return;

    for (i = 0; i < pairs.length; i++) {
        nv = pairs[i].split("=", 2);
        n = decodeURIComponent(nv[0]);
        v = decodeURIComponent(nv[1]);

        if (!parms.hasOwnProperty(n)) parms[n] = [];
        parms[n].push(nv.length === 2 ? v : null);
    }

    if(parms?.forceSMS?.[0] == "true") {
      setForceSMS(true)
    }

    if (parms?.calc) {
      let calcValues = parms?.calc?.[0]?.split(",");

      if (calcValues?.[0] && calcValues?.[0] >= 1) { setAgentCount(calcValues?.[0]) }
      if (calcValues?.[1] && calcValues?.[1] >= 1) { setCommission(calcValues?.[1]) }
      if (calcValues?.[2] && calcValues?.[2] >= 1) { setTransactions(calcValues?.[2]) }
      if (calcValues?.[3] && calcValues?.[3] >= 1 && calcValues?.[3] <= 30) { setYear(calcValues?.[3]) }
    }

    if (parms?.d?.[0]) {
      setExternalUrl(parms?.d?.[0])
    }

}

  useEffect(() => {
    parseURLParams()

    setShowSlider(true)
  }, [])

  useEffect(() => {
    calculate()
  }, [agents, commission, transactions, year])

  return (
    <MainWrapper>
      <GlobalStyles />

      <meta name="viewport" content="width=device-width, initial-scale=1" />

        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&family=Roboto:wght@300;400;500;700;900&display=swap" rel="stylesheet" />

        <CalculatorContainer>

          <EXITLogo src="https://cdn.exitrealty.com/images/exit_logo.png" />

          <Title>RESIDUAL INCOME CALCULATOR</Title>

          <Description>
            The EXIT Formula unlocks explosive earnings potential. Discover how
            much additional income you could earn by trying out our Residual Income
            calculator.
          </Description>


          <BoxesContainer>
            <Box>
              <SvgIconBox style={{ width: '60px' }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path fill="#ffffff" d="M72 88a56 56 0 1 1 112 0A56 56 0 1 1 72 88zM64 245.7C54 256.9 48 271.8 48 288s6 31.1 16 42.3V245.7zm144.4-49.3C178.7 222.7 160 261.2 160 304c0 34.3 12 65.8 32 90.5V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V389.2C26.2 371.2 0 332.7 0 288c0-61.9 50.1-112 112-112h32c24 0 46.2 7.5 64.4 20.3zM448 416V394.5c20-24.7 32-56.2 32-90.5c0-42.8-18.7-81.3-48.4-107.7C449.8 183.5 472 176 496 176h32c61.9 0 112 50.1 112 112c0 44.7-26.2 83.2-64 101.2V416c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32zm8-328a56 56 0 1 1 112 0A56 56 0 1 1 456 88zM576 245.7v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM320 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM240 304c0 16.2 6 31 16 42.3V261.7c-10 11.3-16 26.1-16 42.3zm144-42.3v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM448 304c0 44.7-26.2 83.2-64 101.2V448c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V405.2c-37.8-18-64-56.5-64-101.2c0-61.9 50.1-112 112-112h32c61.9 0 112 50.1 112 112z"/></svg>
              </SvgIconBox>

              <BoxTitle>1. AGENTS</BoxTitle>
              <BoxDescription>My goal is to sponsor this many agents per year</BoxDescription>

              <Input
                value={agents}
                type='number'
                onChange={(event) => {
                  if (event.target.value >=0) {
                    setAgentCount(event.target.value)
                  } else {
                    setAgentCount(0)
                  }
                }}
              />

            </Box>

            <Box>
              <SvgIconBox style={{ width: '30px' }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="#ffffff" d="M160 0c17.7 0 32 14.3 32 32V67.7c1.6 .2 3.1 .4 4.7 .7c.4 .1 .7 .1 1.1 .2l48 8.8c17.4 3.2 28.9 19.9 25.7 37.2s-19.9 28.9-37.2 25.7l-47.5-8.7c-31.3-4.6-58.9-1.5-78.3 6.2s-27.2 18.3-29 28.1c-2 10.7-.5 16.7 1.2 20.4c1.8 3.9 5.5 8.3 12.8 13.2c16.3 10.7 41.3 17.7 73.7 26.3l2.9 .8c28.6 7.6 63.6 16.8 89.6 33.8c14.2 9.3 27.6 21.9 35.9 39.5c8.5 17.9 10.3 37.9 6.4 59.2c-6.9 38-33.1 63.4-65.6 76.7c-13.7 5.6-28.6 9.2-44.4 11V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.1c-.4-.1-.9-.1-1.3-.2l-.2 0 0 0c-24.4-3.8-64.5-14.3-91.5-26.3c-16.1-7.2-23.4-26.1-16.2-42.2s26.1-23.4 42.2-16.2c20.9 9.3 55.3 18.5 75.2 21.6c31.9 4.7 58.2 2 76-5.3c16.9-6.9 24.6-16.9 26.8-28.9c1.9-10.6 .4-16.7-1.3-20.4c-1.9-4-5.6-8.4-13-13.3c-16.4-10.7-41.5-17.7-74-26.3l-2.8-.7 0 0C119.4 279.3 84.4 270 58.4 253c-14.2-9.3-27.5-22-35.8-39.6c-8.4-17.9-10.1-37.9-6.1-59.2C23.7 116 52.3 91.2 84.8 78.3c13.3-5.3 27.9-8.9 43.2-11V32c0-17.7 14.3-32 32-32z"/></svg>
              </SvgIconBox>

              <BoxTitle>2. COMMISSION</BoxTitle>
              <BoxDescription>This is the average commission per deal in my market</BoxDescription>


              <div style={{ position: "relative", width: "100%" }}>
                <Input
                  value={commission}
                  type='number'
                  onChange={(event) => {
                    if (event.target.value >=0) {
                      setCommission(event.target.value)
                    } else {
                      setCommission(0)
                    }
                  }}

                />

                <SvgIconBox style={{ width: '10px',position: "absolute", bottom: 5, left: "10%" ,fontSize: 15, fontWeight: 500 }}>
                  $
                </SvgIconBox>

              </div>
            </Box>

            <Box>
              <SvgIconBox style={{ width: '40px' }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#ffffff" d="M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"/></svg>
              </SvgIconBox>

              <BoxTitle>3. TRANSACTIONS</BoxTitle>
              <BoxDescription>My agents should each close this many transactions annually</BoxDescription>

              <Input
                value={transactions}
                type='number'
                onChange={(event) => {
                  if (event.target.value >=0) {
                    setTransactions(event.target.value)
                  } else {
                    setTransactions(0)
                  }
                }}
              />
            </Box>

          </BoxesContainer>

          <Hr />

          <Results>
            <ResultsDescription>OVER <ResultsDescriptionCount>{ year }</ResultsDescriptionCount> YEARS WITH EXIT</ResultsDescription>
          </Results>


          <ResultsPrice> {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 0, }).format(results)}</ResultsPrice>

          { showSlider && (
            <StyledSlider
              min={1}
              max={30}
              defaultValue={year}
              onChange={(event) => {
                setYear(event)
              }}
              renderTrack={Track}
              renderThumb={Thumb}
            />
          )}

          <ShareButton onClick={() => setShareModal(!shareModal)}>
            <SvgIconBox style={{ width: '15px',marginRight: 10 }}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="#ffffff" d="M352 224H305.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C210.8 374.8 128 333.4 128 240c0-79.5 64.5-144 144-144h80V34.7C352 15.5 367.5 0 386.7 0c8.6 0 16.8 3.2 23.2 8.9L548.1 133.3c7.6 6.8 11.9 16.5 11.9 26.7s-4.3 19.9-11.9 26.7l-139 125.1c-5.9 5.3-13.5 8.2-21.4 8.2H384c-17.7 0-32-14.3-32-32V224zM80 96c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16V384c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V112C0 67.8 35.8 32 80 32h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H80z"/></svg>
            </SvgIconBox>

            SHARE


              { shareModal && (
                <Modal>
                  <ModalContainer>
                    <ShareItem onClick={() => generateShareUrl('facebook')}>
                      <ShareIcon>
                        <SvgIconBox style={{ width: '22px' }}>
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="rgb(30, 48, 80)" d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"/></svg>
                        </SvgIconBox>
                      </ShareIcon>
                      <div>Facebook</div>
                    </ShareItem>
                    <ShareHr />

                    <ShareItem onClick={() => generateShareUrl('twitter')}>
                      <ShareIcon>
                        <SvgIconBox style={{ width: '22px' }}>
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="rgb(30, 48, 80)" d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"/></svg>
                        </SvgIconBox>
                      </ShareIcon>
                      <div>Twitter</div>
                    </ShareItem>
                    <ShareHr />

                    <ShareItemMobile style={{ 
                      display: forceSMS ? "flex" : "none",

                    }} onClick={() => generateShareUrl('sms')}>
                      <ShareIcon>
                        <SvgIconBox style={{ width: '22px' }}>
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path fill="rgb(30, 48, 80)" d="M208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 38.6 14.7 74.3 39.6 103.4c-3.5 9.4-8.7 17.7-14.2 24.7c-4.8 6.2-9.7 11-13.3 14.3c-1.8 1.6-3.3 2.9-4.3 3.7c-.5 .4-.9 .7-1.1 .8l-.2 .2 0 0 0 0C1 327.2-1.4 334.4 .8 340.9S9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5c9.2-3.5 17.8-7.4 25.3-11.4C134.1 343.3 169.8 352 208 352zM448 176c0 112.3-99.1 196.9-216.5 207C255.8 457.4 336.4 512 432 512c38.2 0 73.9-8.7 104.7-23.9c7.5 4 16 7.9 25.2 11.4c18.3 6.9 40.3 12.5 62.1 12.5c6.9 0 13.1-4.5 15.2-11.1c2.1-6.6-.2-13.8-5.8-17.9l0 0 0 0-.2-.2c-.2-.2-.6-.4-1.1-.8c-1-.8-2.5-2-4.3-3.7c-3.6-3.3-8.5-8.1-13.3-14.3c-5.5-7-10.7-15.4-14.2-24.7c24.9-29 39.6-64.7 39.6-103.4c0-92.8-84.9-168.9-192.6-175.5c.4 5.1 .6 10.3 .6 15.5z"/></svg>
                        </SvgIconBox>
                      </ShareIcon>
                      <div>Message</div>
                    </ShareItemMobile>
                    <ShareHr />

                    <ShareItem onClick={() => generateShareUrl('email')}>
                      <ShareIcon>
                        <SvgIconBox style={{ width: '22px' }}>
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="rgb(30, 48, 80)" d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"/></svg>
                        </SvgIconBox>
                      </ShareIcon>
                      <div>Email</div>
                    </ShareItem>
                    <ShareHr />

                    <CloseItem onClick={() => setShareModal(false)}>
                      Close
                    </CloseItem>

                  </ModalContainer>
                </Modal>
              )}
          </ShareButton>

          <Footer>
            * This fun residual income calculator is an estimation tool only, designed to help you evaluate the unlimited income potential of the EXIT Formula. The results displayed do not take into consideration factors such as the sponsoring bonus fee, variations in agent and sponsor productivity, and more.
          </Footer>

          <Footer style={{ color: 'white', fontSize: 2 }}>Build: 20/07/2023 | Version: 2</Footer>

        </CalculatorContainer>
    </MainWrapper>
  );
}

export default App;
